module.exports = __webpack_public_path__ + "static/media/times-square.c16c2b56.svg";